import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  titleBlue: {
    color: '#1671ED',
    cursor: 'move',
  },
  dialog: {
    // marginTop: '6%',
    maxheight: '900px',
    minHeight: '68%',
  },
  container: {
    display: 'flex',
    width: '800px',
    maxWidth: '800px',
    height: '100%',
    padding: '35px',
    flexDirection: 'column',
    borderTop: '2px solid #E3E3E3',
    overflowX: 'hidden',
  },
  subcontainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  dialogAction: {
    padding: '20px 30px',
  },
  dialogAction2: {
    marginTop: '-70px',
    padding: '20px 30px',
  },
  scroll: {
    overflowY: 'auto',
    overflowX: 'hidden',
    margin: '0 8px 8px 0',

    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#E3E3E3',
      borderRadius: '20px',
      margin: '30px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'gray',
      borderRadius: '20px',
      border: '3px solid gray',
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  button: {
    height: '40px',
    width: '140px',
    padding: '10px 16.5px',
    marginLeft: '40px',
    marginTop: '10px',
  },
  link: {
    height: '40px',
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '10px',
    marginLeft: '40px',
  },
  footer: {
    padding: '30px 30px 25px 0px',
  },
  icon: {
    fontSize: '22px',
  },
  labels: {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '10px',
    color: '#141414',
  },
  label: {
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '10px',
    color: '#696969',
  },
  inlineLabel: {
    display: 'flex',
    gap: '6px',
  },
  required: {
    color: '#C90000',
  },
  selectPlaceholder: {
    fontSize: '16px',
    width: '340px',
  },
  selectPlaceholder2: {
    fontSize: '16px',
    width: '365px',
  },
  editMessage: {
    marginBottom: '10px',
  },
  wrapper: {
    width: '100%',
    margin: '0px',
  },
  subjectWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
  subjectField: {
    display: 'flex',
    width: '100%',
    fontSize: '20px',
    color: '#B4B4B4',
    paddingBottom: '6px',
  },
  textField: {
    fontSize: '20px',
    height: '152px',
  },
  messageWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
    paddingBottom: '20px',
    borderBottom: '1px solid #E3E3E3',
  },
  messageTitle: {
    fontWeight: '600',
    fontSize: '20px',
    color: '#141414',
    marginBottom: '12px',
  },
  messageBody: {
    fontWeight: '400',
    fontSize: '16px',
    color: '#696969',
    marginBottom: '12px',
    width: '100%',
    overflowWrap: 'break-word',
  },
  messageFooter: {
    fontWeight: '400',
    fontSize: '16px',
    color: '#B4B4B4',
  },
  linkButton: {
    textDecorationLine: 'underline',
    color: '#1671ED',
    border: 0,
    width: '200px',
    marginLeft: '20px',
    '&:hover': {
      border: 0,
    },
  },
}))
